/**
 * File: apps/qbench-cp/reactapp/src/shared/stub/orders.js
 *
 * Purpose: Provides a mock orders API for local development/testing when stubs are enabled.
 *
 * Scope: Frontend API stubs for the customer portal.
 *
 * Tags: customer-portal
 *
 * Overview: Exposes create, get, update, delete, and all (paginated list) functions that return
 *     canned order fixture data only when REACT_APP_STUBS_ENABLED is "true", echoing input
 *     values back for create/update/get and returning a fixed list of five orders for `all`.
 *
 * Exports: OrderStub object.
 */
import { getRuntimeConfig } from 'shared/configs/runtimeConfig';
const RETURN_STUB = getRuntimeConfig().stubsEnabled;

export const OrderStub = {
  create: (order) => RETURN_STUB && { data: order },
  get: (id) =>
    RETURN_STUB && {
      data: {
        id,
        customer_account_id: 1,
      },
    },
  update: (order) => RETURN_STUB && { data: order },
  delete: (id) => RETURN_STUB && { data: { message: 'OK' } },
  all: (page = 1, pageSize = 20) =>
    RETURN_STUB && {
      data: [
        { id: 1, customer_account_id: 1 },
        { id: 2, customer_account_id: 1 },
        { id: 3, customer_account_id: 1 },
        { id: 4, customer_account_id: 1 },
        { id: 5, customer_account_id: 1 },
      ],
    },
};
